import { useState, useEffect } from "react";
import TicketsListMain from "./TicketsListMain";
import TicketsListLogin from "./TicketsListLogin";
import { serverURL } from "../helpers/Helpers";

const TicketsList = () => {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(serverURL + "/me", { credentials: "include" })
      .then((r) => r.json())
      .then((data) => { if (data.status === "OK") setUser(data.userDetails); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div style={{ padding: "20px" }}>Loading…</div>;
  if (!user)   return <TicketsListLogin onLogin={setUser} />;
  return <TicketsListMain sites={user.sites} onLogout={() => setUser(null)} />;
};

export default TicketsList;
